/** Cal.com configuration + link builder.
 *
 * Accepts either CAL_USERNAME (preferred — shorter) or CAL_URL (use for a
 * specific event type like /dmerritts/intro). Returns a link that's safe to
 * set on <a href>. If neither is configured, falls back to mailto:. */

import { CAL_USERNAME, CAL_URL } from './env';

const fallbackEmail = 'questions@danmerritts.com';

export function getBookingHref(): string {
  if (CAL_URL) return CAL_URL;
  if (CAL_USERNAME) return `https://cal.com/${CAL_USERNAME}`;
  return `mailto:${fallbackEmail}?subject=Meeting%20request`;
}

export function isCalConfigured(): boolean {
  return Boolean(CAL_USERNAME || CAL_URL);
}
